const mod = crateImports["@xing-com/crate-xinglet/internal"];
const { InternalXingletLoader,RouteProvider,RuntimeProvider,context,createServerRequest,getEntryPointConfig,useRuntime,useRuntimeConfig } = mod;
export { InternalXingletLoader,RouteProvider,RuntimeProvider,context,createServerRequest,getEntryPointConfig,useRuntime,useRuntimeConfig };
export default mod.default ?? mod;